// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1740080081023
      var cssReload = require("D:/Uscreen/wordpress/wp-content/themes/uscreen_v5/design-system/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  